(function () {
  function initHost(host) {
    if (host.dataset.cvNavInit === 'true') return;

    const swiperEl = host.querySelector('.collections-navigator-swiper');
    const paginationEl = host.querySelector('.collections-navigator-swiper__pagination');
    if (!swiperEl || !paginationEl) return;

    host.dataset.cvNavInit = 'true';

    const mq = window.matchMedia('(max-width: 749px)');
    let instance = null;
    let rafAttempts = 0;

    function mount() {
      if (instance || !mq.matches) return;

      if (typeof window.Swiper !== 'function') {
        if (rafAttempts < 150) {
          rafAttempts += 1;
          requestAnimationFrame(mount);
        }
        return;
      }

      rafAttempts = 0;

      instance = new window.Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        watchOverflow: true,
        observer: true,
        observeParents: true,
      });

      requestAnimationFrame(function () {
        if (instance) instance.update();
      });
    }

    function unmount() {
      if (!instance) return;
      instance.destroy(true, true);
      instance = null;
    }

    function apply() {
      if (mq.matches) mount();
      else unmount();
    }

    mq.addEventListener('change', apply);
    apply();
  }

  function scan(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-collections-navigator-swiper]').forEach(initHost);
    if (root && root.matches && root.matches('[data-collections-navigator-swiper]')) {
      initHost(root);
    }
  }

  function boot() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
